export const deferUntilIdle = (fn, { timeout = 5000 } = {}) => {
  if (typeof window === "undefined") return () => {};

  if ("requestIdleCallback" in window) {
    const id = window.requestIdleCallback(() => fn(), { timeout });
    return () => window.cancelIdleCallback(id);
  }

  const timer = setTimeout(fn, Math.min(timeout, 2000));
  return () => clearTimeout(timer);
};

export const isPropertyDetailsPage = () =>
  typeof window !== "undefined" &&
  /^\/homes\/home-details\//.test(window.location.pathname);

export const hasFirebaseAuthPersistence = () => {
  try {
    return Object.keys(localStorage).some((key) =>
      key.startsWith("firebase:authUser")
    );
  } catch {
    return false;
  }
};
